export const WAVEFORM_BARS = [3, 6, 10, 14, 10, 18, 10, 14, 10, 6, 3].map(
  (height, index) => ({
    id: `waveform-bar-${index}`,
    height,
    animationDelay: `${index * 0.08}s`,
  })
);

// 2× scaled for the fullscreen lightbox variant.
export const WAVEFORM_BARS_LIGHTBOX = [
  6, 12, 20, 28, 20, 36, 20, 28, 20, 12, 6,
].map((height, index) => ({
  id: `waveform-bar-lightbox-${index}`,
  height,
  animationDelay: `${index * 0.08}s`,
}));
